import { render } from "./pageWidgets.vue?vue&type=template&id=c50358a2&scoped=true"
import script from "./pageWidgets.vue?vue&type=script&lang=js"
export * from "./pageWidgets.vue?vue&type=script&lang=js"

import "./pageWidgets.vue?vue&type=style&index=0&id=c50358a2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50358a2"]])

export default __exports__